import React, { useState, useContext, useRef, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { OverlayPanel } from "primereact/overlaypanel";
import { ServiceContext } from "../../data/services/ServiceContext";
import { PersonContext } from "../../data/personel/PersonContext";
import { ActionContext } from "../../data/action/ActionContext";
import { SubActionContext } from "../../data/action/SubActionContext";
import { FaSearch, FaInfoCircle } from "react-icons/fa";
import { LuChevronDown, LuChevronRight } from "react-icons/lu";
import "../../css/QuickAssing.css";

const QuickAssignModal = ({ show, handleClose }) => {
  const { services } = useContext(ServiceContext);
  const { persons } = useContext(PersonContext);
  const { actions } = useContext(ActionContext);
  const { subActions } = useContext(SubActionContext);

  const [selectedServices, setSelectedServices] = useState([]);
  const [selectedPersons, setSelectedPersons] = useState([]);
  const [columnFilters, setColumnFilters] = useState({});
  const [columnsOpen, setColumnsOpen] = useState({});
  const [windowMode, setWindowMode] = useState(window.innerWidth < 768 ? "mobile" : "desktop");
  const [mounted, setMounted] = useState(false);

  const serviceFilterOp = useRef(null);
  const personFilterOp = useRef(null);

  useEffect(() => {
    setMounted(true);
    const handleResize = () => setWindowMode(window.innerWidth < 768 ? "mobile" : "desktop");
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const resolveActionInfo = (row) => {
    const assignedAction = actions?.find((a) => a.id === row.actionId);
    const actionName = assignedAction?.name || row.actionName || "Beklemede";
    const sub = row.subActionId ? subActions?.find((sa) => sa.id === row.subActionId) : null;
    const subActionName = sub?.name || null;
    return { actionName, subActionName };
  };

  const statusOptions = Array.from(new Set(services.map(s => resolveActionInfo(s).actionName)));

  const toggleColumn = (field) => {
    setColumnsOpen((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const assignServices = () => {
    if (!selectedServices.length || !selectedPersons.length) {
      alert("Lütfen en az bir servis ve bir personel seçin!");
      return;
    }
    selectedServices.forEach(service => {
      selectedPersons.forEach(person => {
        console.log(`Servis "${service.serviceFullName}" atandı -> Personel: ${person.firstName} ${person.lastName}`);
      });
    });
    setSelectedServices([]);
    setSelectedPersons([]);
    handleClose();
  };

  const rowClassNameService = (rowData) =>
    selectedServices.includes(rowData) ? "selected-row" : "bordered-row";
  const rowClassNamePerson = (rowData) =>
    selectedPersons.includes(rowData) ? "selected-row" : "bordered-row";

  const tableStyle = { fontSize: "0.85rem" };
  const headerStyle = { paddingLeft: "0.75rem", lineHeight: "1.2rem", fontSize: "0.85rem" };
  const searchBoxStyle = { width: "42%", display: "flex", alignItems: "center", padding: "0.25rem 0.5rem", border: "1px solid #ccc", borderRadius: "5px", marginBottom: "0.5rem", background: "#fff", gap: "0.5rem" };
  const searchInputStyle = { border: "none", outline: "none", flex: 1, fontSize: "0.85rem", boxShadow: "none" };

  const serviceColumns = [
    { field: "serviceFullName", header: "Servis Adı" },
    { field: "customerName", header: "Müşteri" },
    { field: "status", header: "Durum", type: "checkbox", options: statusOptions },
  ];

  const personColumns = [
    { field: "firstName", header: "Ad" },
    { field: "lastName", header: "Soyad" },
    { field: "expertise", header: "Uzmanlık", type: "checkbox", options: ["Frontend", "Backend", "Mobil", "DevOps"] },
    { field: "location", header: "Şehir" },
  ];

  const renderFilterPanel = (columns, opRef) => (
    <OverlayPanel
      ref={opRef}
      appendTo={document.body}
      dismissable={windowMode !== "mobile"}
      style={{
        width: windowMode === "mobile" ? "100%" : "320px",
        position: windowMode === "mobile" ? "absolute" : "fixed",
        top: windowMode === "mobile" ? 0 : "100px",
        left: windowMode === "mobile" ? 0 : "calc(50% - 160px)",
        padding: "1rem",
        overflowY: "auto",
        maxHeight: windowMode === "mobile" ? "100vh" : "80vh",
        zIndex: 1000,
      }}
      onShow={() => (document.body.style.overflow = "hidden")}
      onHide={() => (document.body.style.overflow = "auto")}
    >
      {columns.map(col => {
        const open = columnsOpen[col.field] || false;
        const value = columnFilters[col.field] || "";
        return (
          <div key={col.field} className="border-b border-gray-200 py-2">
            <button className="flex justify-between items-center w-full text-left px-2 py-2 hover:bg-gray-50"
              onClick={() => toggleColumn(col.field)}>
              {col.header} <span>{open ? <LuChevronDown /> : <LuChevronRight />}</span>
            </button>
            {open && (
              <div className="flex flex-col mt-2 gap-2">
                {col.type === "checkbox" ? (
                  <div className="grid grid-cols-2 gap-2">
                    {col.options.map(opt => (
                      <label key={opt} className="flex items-center gap-2 cursor-pointer text-[0.65rem]">
                        <input type="checkbox"
                          checked={Array.isArray(value) ? value.includes(opt) : false}
                          onChange={(e) => {
                            let newValues = Array.isArray(value) ? [...value] : [];
                            if (e.target.checked) newValues.push(opt);
                            else newValues = newValues.filter(v => v !== opt);
                            setColumnFilters({ ...columnFilters, [col.field]: newValues });
                          }} />
                        {opt}
                      </label>
                    ))}
                  </div>
                ) : (
                  <input type="text" placeholder={`${col.header} ara...`} value={value}
                    onChange={(e) => setColumnFilters({ ...columnFilters, [col.field]: e.target.value })}
                    className="border border-gray-300 rounded px-2 py-1" />
                )}
              </div>
            )}
          </div>
        );
      })}
      <div className="flex gap-2 mt-4">
        <Button label="Temizle" className="button-secondary flex-1" onClick={() => setColumnFilters({})} />
        <Button label="Uygula" className="button-primary flex-1" onClick={() => opRef.current.hide()} />
      </div>
      {windowMode === "mobile" && (
        <button onClick={() => opRef.current.hide()} className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 text-3xl font-bold">&times;</button>
      )}
    </OverlayPanel>
  );

  const filteredServices = services.filter(s => {
    if (columnFilters["serviceFullName"] && !s.serviceFullName.toLowerCase().includes(columnFilters["serviceFullName"].toLowerCase())) return false;
    const statusFilter = columnFilters["status"];
    const { actionName } = resolveActionInfo(s);
    if (statusFilter && statusFilter.length && !statusFilter.includes(actionName)) return false;
    return true;
  });

  const filteredPersons = persons.filter(p => {
    if (columnFilters["firstName"]) return p.firstName.toLowerCase().includes(columnFilters["firstName"].toLowerCase());
    return true;
  });

  return (
    <Modal show={show} onHide={handleClose} size={windowMode === "mobile" ? "xl" : "xl"} centered>
      <Modal.Header closeButton>
        <Modal.Title>Hızlı Servis Ata</Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ overflowY: "auto" }}>
        <p style={{ fontSize: "0.85rem", color: "#777", marginBottom: "1rem", display: "flex", alignItems: "center", gap: "0.4rem" }}>
          <span>Lütfen atamak istediğiniz servisleri ve personelleri seçin.</span>
          <FaInfoCircle color="#777" style={{ cursor: "pointer", fontSize: "1rem" }} />
        </p>

        <div style={{
          display: "flex",
          gap: "1.5rem",
          flexWrap: "wrap",
          flexDirection: windowMode === "mobile" ? "column" : "row"
        }}>
          {/* Servisler */}
          <div style={{ flex: 1, minWidth: windowMode === "mobile" ? "100%" : 450 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.6rem" }}>
              <h5 className="m-0">Servisler</h5>
              <span style={{ fontSize: "0.85rem", color: "#555" , paddingRight:5}}>Seçilen: {selectedServices.length}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
              <div style={searchBoxStyle}>
                <FaSearch color="#666" />
                <InputText value={columnFilters["serviceFullName"] || ""} placeholder="Servis ara..."
                  onChange={e => setColumnFilters({ ...columnFilters, serviceFullName: e.target.value })}
                  style={searchInputStyle} />
              </div>
              {mounted && <Button style={{ fontSize: 12 ,paddingRight:15}} label="Filtre" icon="pi pi-filter" onClick={e => serviceFilterOp.current.toggle(e)} />}
            </div>
            <div style={{ border: "1px solid #ccc", borderRadius: "8px", overflow: "auto", maxHeight: windowMode === "mobile" ? 250 : 350 }}>
              <DataTable value={filteredServices} selection={selectedServices} onSelectionChange={e => setSelectedServices(e.value)}
                selectionMode="checkbox" dataKey="id" scrollable={false} rowClassName={rowClassNameService} tableStyle={tableStyle}>
                <Column selectionMode="multiple" headerStyle={{ width: "3rem", textAlign: "center", padding: 5 }} />
                <Column field="id" header="ID" sortable style={{ width: "10%" }} headerStyle={headerStyle} />
                <Column field="serviceFullName" header="Servis Adı" sortable style={{ width: "30%" }} headerStyle={headerStyle} />
                <Column field="customerName" header="Müşteri" sortable style={{ width: "25%" }} headerStyle={headerStyle} />
                <Column header="Durum" sortable body={row => {
                  const { actionName, subActionName } = resolveActionInfo(row);
                  return (
                    <div className="flex flex-col gap-1 leading-tight">
                      <span className="font-semibold">{actionName}</span>
                      {subActionName && <span className="text-gray-500 text-md">{subActionName}</span>}
                    </div>
                  );
                }} style={{ width: "25%" }} />
              </DataTable>
            </div>
          </div>

          {/* Personeller */}
          <div style={{ flex: 1, minWidth: windowMode === "mobile" ? "100%" : 450 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
              <h5 className="m-0">Personeller</h5>
              <span style={{ fontSize: "0.85rem", color: "#555" ,paddingRight:5 }}>Seçilen: {selectedPersons.length}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "0.5rem" }}>
              <div style={searchBoxStyle}>
                <FaSearch color="#666" />
                <InputText value={columnFilters["firstName"] || ""} placeholder="Personel ara..."
                  onChange={e => setColumnFilters({ ...columnFilters, firstName: e.target.value })}
                  style={searchInputStyle} />
              </div>
              {mounted && <Button style={{ fontSize: 12 ,paddingRight:15}} label="Filtre" icon="pi pi-filter" onClick={e => personFilterOp.current.toggle(e)} />}
            </div>
            <div style={{ border: "1px solid #ccc", borderRadius: "8px", overflow: "auto", maxHeight: windowMode === "mobile" ? 250 : 350 }}>
              <DataTable value={filteredPersons} selection={selectedPersons} onSelectionChange={e => setSelectedPersons(e.value)}
                selectionMode="checkbox" dataKey="id" scrollable={false} rowClassName={rowClassNamePerson} tableStyle={tableStyle}>
                <Column selectionMode="multiple" headerStyle={{ width: "3rem", textAlign: "center", padding: 5 }} />
                <Column field="id" header="ID" sortable headerStyle={headerStyle} />
                <Column field="firstName" header="Ad" sortable headerStyle={headerStyle} />
                <Column field="lastName" header="Soyad" sortable headerStyle={headerStyle} />
                <Column field="expertise" header="Uzmanlık" body={row => row.expertise?.join(", ")} sortable headerStyle={headerStyle} />
                <Column field="location" header="Şehir" sortable headerStyle={headerStyle} />
              </DataTable>
            </div>
          </div>
        </div>

        <div style={{ fontSize: "0.85rem", color: "#555", marginTop: "1rem" }}>
          Toplam seçilen servis: {selectedServices.length}, personel: {selectedPersons.length}
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button label="Otomatik Ata" onClick={assignServices} className="button-primary" />
        <Button label="İptal" onClick={handleClose} className="button-secondary" />
      </Modal.Footer>

      {mounted && renderFilterPanel(serviceColumns, serviceFilterOp)}
      {mounted && renderFilterPanel(personColumns, personFilterOp)}
    </Modal>
  );
};

export default QuickAssignModal;
